<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/108NRmk/tc-custom/9781611520811.jpg?1723406213745" alt="This image is the cover for the book Pleasure Cruise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pleasure Cruise
      </h1>
      <p class="bookDescription body article font2">
        <p>When Andy agrees to join his friends Reese and Palmer on a two-week cruise during their winter break from college, he's secretly hoping to score with some hot Latino lover.<br/><br/>Little does he expect his friends to crimp his style, or scare off the only sexy, single guy on the ship ... their waiter, Carlos.<br/><br/>Can he salvage the trip and entice the sexy crewman to pay a visit to his cabin for a little<em>mano a mano</em>time alone?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78a59743